"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageContent = void 0;
var _Content = require("./Content");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Error page content with prepared translations ready to go.
 */
const ErrorPageContent = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Root, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Content.Content, {
    ...props
  })
});
exports.ErrorPageContent = ErrorPageContent;
